import React, { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import { Container, Heading, HtmlHead } from '@domain/components';
import { routes } from '@domain/constants';
import { RootState } from '@domain/root-reducer';

import FrontOffice from './FrontOffice';

const Flow: FC = () => {
  const { frontOffice, nieuw, } = routes;

  const pid = useSelector((state: RootState) => state.pid)
  const branding = useSelector((state: RootState) => state.branding)
  const location = useLocation();

  const redirectToPortal = useCallback(() => {
    const portalRedirectURL = process.env.REACT_APP_CP_DI_URL + nieuw + '?PID=' + pid + '&BSID=' + pid;
    !!pid && pid !== '' && window.location.replace(portalRedirectURL);
    return undefined
  }, [pid, nieuw]);

  if (pid === null) {
    return <> </>;
  }

  const faviconCustom = !!branding && !!branding.favicon ? branding.favicon : undefined;
  if (location.pathname === nieuw) {
    return (
      <Routes>
        <Route path={nieuw} element={redirectToPortal()} />
      </Routes>
    )
  }
  if (pid === '') {
    return (
      <React.Fragment>
        <Container justifyContent="center" alignItems="center" padding={'10px'}>
          <Heading level={1}>
            Sorry er is iets misgegaan. Neem contact op met uw verzekeraar.
          </Heading>
        </Container>
      </React.Fragment>
    )
  }
  return (
    <React.Fragment>
      <HtmlHead faviconCustom={faviconCustom} />
      <Routes>
        <Route path={frontOffice} element={<FrontOffice />} />
        <Route path=":fid" element={<FrontOffice />} />
        <Route path="*" element={<Navigate to={frontOffice} replace />} />
      </Routes>
    </React.Fragment>
  )
};

export default Flow;
